$(function(){
	var loader = $('.loader-wrap');
	var video = document.getElementById('main-video');

	// ページの読み込みが完了したらアニメーションを非表示
	$(window).on('load', function() {
		loader.fadeOut().promise().done(function() {
			video.play();
		});
	});

	// ページの読み込みが完了してなくても3秒後にアニメーションを非表示にする
	/*setTimeout(function() {
		loader.fadeOut().promise().done(function() {
			video.play();
		});
	}, 3000);*/
});
